import { withRouter, useRouteMatch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect,useRef } from "react";
//import PhoneInput from "react-phone-input-2";
import PhoneInput from "react-phone-input-2";
import { flushCart } from "../redux/cartSlice";
import { auth, callFunction, firestore, messaging,app  } from "../provider/firebase";
import { signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import {  doc,getDoc } from "firebase/firestore"; 
import axios from "axios";
import moment, { lang } from 'moment';
import { calculateKuver, calculateOrderPrice, exportLogo, getHostName, inputAlert, parsePrice, somethingWentWrong, successMessage } from "../provider/functions";
import { getToken,isSupported,getMessaging } from "firebase/messaging";
import MySelectBox from "../components/MySelectBox";
import MyTimePicker,{MyTimePicker2} from "../components/MyTimePicker";
import Swal from "sweetalert2";
export default withRouter(PayTable);
function PayTable({ history }) {
  const dispatch = useDispatch();
  let match = useRouteMatch();

  //const [step, setstep] = useState(1);
  const [loading, setloading] = useState(false);
  const [adsoyad, setadsoyad] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [user, setuser] = useState(false);
  const [odemeyontemi, setodemeyontemi] = useState("");
  const [pushState, setpushState] = useState({});
 
  const [bildirim, setbildirim] = useState("");
  const [cardList, setcardList] = useState([]);
  const language = useSelector((state) => state.language.data);
  const selectedLang = useSelector((state) => state.language.selected);
  const serverReducer = useSelector((state) => state.server.data);
  const isWebStore = match.params.table=="webstore" || match.params.table=="online";
  const currency = serverReducer.currency;
  const cart = useSelector((state) => state.cart.data);
  const toplam = parseFloat( parseFloat( cart.map(v=>calculateOrderPrice(v)).reduce((a, b) => a + b, 0)).toFixed(2))
  const {freekargo,kargo,min,open,payments} = serverReducer.webstore || {open:false,min:0,kargo:0,freekargo:0,payments:[]}
  const options = [{label:language.odeme_yontemi_online_odeme,value:"paytr"},...payments.map(v=>({label:v,value:v}))].filter(v=>v.value!="paytr" || (v.value=="paytr" && serverReducer.paytr));
  async function onSignInSubmit(){
    if(adsoyad.length<3  ){
      return somethingWentWrong( language.hata,language.bilgileri_doldurun)
    }
    setloading(true);
    const access_token = await  auth.currentUser?.getIdToken();

    if(odemeyontemi.includes("paytr") || pushState?.entegrasyon=="paytr" ){
      return  history.replace((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/paytr",{adsoyad,...pushState});
    }
    callFunction("payTable")({
      access_token,
      server: match.params.server ? match.params.server : getHostName(),
      cart,
      table:match.params.table,
      name: adsoyad,
      phone:phoneNumber,
      notification:bildirim,
      paymentNote:odemeyontemi,
      paymentMethod:odemeyontemi
    }).then((res)=>{
      if (res.data.error) {
        if(res.data.error=="recaptcha-error"){
          return Swal.fire("Recaptcha!", language.recaptcha, "error");
        }if (res.data.error == "server-not-found") {
          return Swal.fire("Hata!", language.restorant_not_found, "error");
        }else if (res.data.error == "cart-not-found") {
          history.goBack();
          return Swal.fire("Hata!", language.sepette_urun_yok, "error");
        }else if (res.data.error == "name-not-found") {
          return Swal.fire("Hata!", language.ad_zorunlu, "error");
        }else if (res.data.error == "table-not-found") {
          return Swal.fire("Hata!", language.masa_zorunlu, "error");
        }else if (res.data.error == "webstoreclosed") {
          return somethingWentWrong("Hata!", language.webstore_kapali_baslik, "error");
        }else if (res.data.error == "minprice") {
          return somethingWentWrong("Hata!", language.minimum_tutar_altinda_baslik, "error");
        }else if (res.data.error == "paymentmethod") {
          return somethingWentWrong("Hata!", language.odeme_yontemi_zorunlu, "error");
        }
      }
      if (res.data.success == true) {
        if(res.data.url){
          window.location=res.data.url;
          return;
        }
        history.replace((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/welcome",{adsoyad,...pushState})
        dispatch(flushCart());
        return successMessage(
          language.basarili,
          language.siparis_iletildi,
          "success"
        );
      }
      return somethingWentWrong(
       language.hata,
        language.birseyler_ters_gidiyor,
        "error"
      );
    })
    .finally(()=>setloading(false))
  }
  
  useEffect(  ()=>{
    let subscribe = Promise.resolve();
    async function main(){
      [...cart].length==0 &&  history.replace((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/welcome")
       subscribe = auth.onAuthStateChanged(userData=>{
        if(userData) {
          setuser(userData)
          setphoneNumber(userData.phoneNumber)
          setadsoyad(userData.displayName || "");
        }
      })
      if(options.length>0) setodemeyontemi(options[0].value)
      if(serverReducer.paytr){
        setloading(true)
         const access_token = await  auth.currentUser?.getIdToken();
        callFunction("paytrCardList")({
          access_token,
          server: match.params.server ? match.params.server : getHostName(),
        }).then((res)=>{
          if(res?.data?.success){
            const data = [...res.data.data]
            setcardList(data);
          }
        }).finally(()=>setloading(false))
      }
    }
    main();
    return ()=>subscribe();
  },[])

  return (
    <div>
      <div className="rp-app rp-search">
        <div className="container-fluid">
          <div className="rp-page-body " style={{ marginBottom: 100 }}>
            <div className="rp-page-header" style={{backgroundImage:"linear-gradient(205deg, "+serverReducer.bgcolor2+", "+serverReducer.bgcolor1+")"}}>
              <div className="rp-hh-content flex-between">
                <div className="area">
                  <a onClick={history.goBack} className="link">
                    <i className="fa fa-arrow-left" />
                  </a>
                </div>
                <div className="area">
                  <div className="logo">
                    <img
                      src={
                        serverReducer.image
                          ? serverReducer.image
                          : "../"+exportLogo(serverReducer.host)
                      }
                      alt="Logo"
                    />
                  </div>
                </div>
                <div className="area" style={{minWidth:40}}>
                  {/* <a className="link">
                    <i className="fa fa-bell" />
                  </a> */}
                </div>
              </div>
            </div>

          
              <h2 className="rp-page-name-mini" style={{color:serverReducer.textColor}}>{language.cari_hesaplar_ad}</h2>
              <div className="mb-4">
                <input
                  className="form-control rp-input-text"
                  placeholder="Joe Doe"
                  value={adsoyad}
                  onChange={(e) => setadsoyad(e.target.value)}
                ></input>
              </div>

              <h2 className="rp-page-name-mini" style={{color:serverReducer.textColor}}>{language.odeme_yontemi}</h2>
              
              <div className="btn-group rp-checkout-buttons" >
               {cardList.map((v,k)=><a className="btn btn-outline-dark" style={{border:"0.1px solid black",backgroundColor:odemeyontemi==v.ctoken?'orange':'white',color:odemeyontemi==v.ctoken?'white':'black'}}key={k} onClick={()=>{setodemeyontemi(v.ctoken);setpushState(v)}}><div className="img"><img src={"../../assets/img/"+String(v.schema).toLowerCase()+".png"} /></div> ****-****-****-{v.last_4}</a>)}
               {options.map((v,k)=><a className="btn btn-outline-dark" style={{border:"0.1px solid black",backgroundColor:odemeyontemi==v.value?'orange':'white',color:odemeyontemi==v.value?'white':'black'}} key={k} onClick={()=>{setodemeyontemi(v.value);if(v.value=="paytr") setpushState({})}}><div className="img"><img src={"../../assets/img/"+(v.value=="paytr"?"credit-card.png":"cash-payment.png")} /></div> {v.label}</a>)}
              </div>
              {/* {bildirim.length<3 &&<button className="btn  btn-block" style={{backgroundColor:'black',color:'white',marginTop:20,marginBottom:20}} onClick={e=>{e.preventDefault();requestPushNotification()}}>
                 Sipariş Durumlarını Bildirim Olarak Al
              </button>} */}
            <div className="rp-action-margin-cart" />
            <div style={{height:100}}/>
          </div>
        </div>
      </div>

      <div className="rp-action rp-action-cart">
      <center style={{ paddingBottom: 20,display:'block' }}> 
       <div id="recaptcha-container" className="recaptcha-container"/>
            </center>
        
        <button
          className="btn btn-dark btn-block"
          onClick={onSignInSubmit}
          style={{backgroundColor:serverReducer.buttonColor,borderColor:serverReducer.buttonColor,color:"white"}}
          disabled={ loading || cart.length==0}
        >
          {loading ? (
            <div className="spinner-border text-light" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            `${language.siparis_ver} ${toplam+(serverReducer.kuver?calculateKuver(serverReducer.kuver,cart):0)} ${currency}`
          )}
        </button>
      </div>
    </div>
  );
}
